/// <field name='lc' type='Object'>Labour charges object</field>
window.stockmgt = cafm.stockmgt = {
    requiesRefresh:false,
    init: function (e) {
        /// <summary>Stock Module initialiser</summary>
        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Stock);

        let processOnInit = true;
        if (e.route && e.route.routeKey && e.route.routeKey != "") {
            processOnInit = false;
        }

        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.stockmgt.nav.routes,
            processOnInit: processOnInit,
            cache: true,
            'default': 'StockList',
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null
        });
        // handle top level searches
        cafm.handlers.set('cafm.search', cafm.stockmgt.topLevelSearch);
    },
    nav: {
        routes: {
            StockBalances: {
                path: "stockbalances",
                handler: function handler() {
                    cafm.views.main({
                        url: cafm.url.get('/StockManagement/stockbalances')
                    });
                },
                onPreRouteChange: function (e) { return cafm.stockmgt.onPreRouteChange(e); },
                documentTitle: "Stock"
            },
        }
    },
    displayStockDetails: function (id) {
        if (!id) {
            var crit = $('#' + cafm.res.consts.ElementId_StockBalanceForm).getViewModel();
            id = crit.StockID;
        }
        var actionOpts = {
            action: cafm.url.get('/StockManagement/StockDetails/{0}'.format(id)),
            title: cafm.res.str.TitleStockDetail,
            minHeight: 300,
            isForm: true
        };
        cafm.views.openChildActionWindow(actionOpts);
        cafm.scanner.close();
        return false;
    },
    onPreRouteChange: function (e) {
        if (cafm.isMobile()) {
            var mm = $('#mobileMenu');
            if (mm.is(':visible')) {
                mm.slideUp();
            }
        }
        return true;
    },
    displayStockBalance: function (id) {
        id = id ? id : cafm.stockmgt.getIdFromBalanceVM();
        cafm.views.closeActionWindow();
        var actionOpts = {
            action: cafm.url.get('/StockManagement/StockBalance/?id={0}&allowStockActions={1}'.format(id, false)),
            title: cafm.res.str.TitleStockDetail,
            isForm: true
        };
        cafm.views.openChildActionWindow(actionOpts);
        return false;
    },
    adjustStockBalance: function (id) {
        id = id ? id : cafm.stockmgt.getIdFromBalanceVM();
        cafm.views.closeActionWindow();
        var actionOpts = {
            action: cafm.url.get('/StockManagement/StockAdjustBalance/{0}'.format(id)),
            title: cafm.res.str.TitleStockAdjustBalance,
            minHeight: 300,
            isForm: true,
            onWindowClose: function () {
                cafm.stockmgt.refreshBalancesView();
            }
        };
        cafm.views.openChildActionWindow(actionOpts);
        return false;
    },
    transferStockBalance: function (id) {
        id = id ? id : cafm.stockmgt.getIdFromBalanceVM();
        cafm.views.closeActionWindow();
        var actionOpts = {
            action: cafm.url.get('/StockManagement/StockTransfer/{0}'.format(id)),
            title: cafm.res.str.TitleTransferStock,
            minHeight: 300,
            isForm: true,
            onWindowClose: function () {
                cafm.stockmgt.refreshBalancesView();
            }
        };
        cafm.views.openChildActionWindow(actionOpts);
        return false;
    },
    updateBinLocation: function (id) {
        id = id ? id : cafm.stockmgt.getIdFromBalanceVM();
        cafm.views.closeActionWindow();
        var actionOpts = {
            action: cafm.url.get('/StockManagement/StockUpdateBinLocation/{0}'.format(id)),
            title: cafm.res.str.TitleStockUpdateBinLocation,
            isForm: true,
            onWindowClose: function () {
                cafm.stockmgt.refreshBalancesView();
            }
        };
        cafm.views.openChildActionWindow(actionOpts);
        return false;
    },
    prepareChangeStoreroom: function () {
        var div = $('#' + cafm.res.consts.ElementId_ChangeDefaultStoreroom);
        div.prepareForm().fadeIn();
        var vm = cafm.stockmgt.getDefaultStoreroom();
        if (vm)
        {
            div.bindViewModel(vm);
        }
    },
    cacheDefaultStoreroom: function (store,forceReset)
    {
        if (store)
        {
            let cachedStr = cafm.stockmgt.getDefaultStoreroom();
            if (!cachedStr || forceReset){
                cafm.cache.session.set(cafm.res.consts.CacheKey_DefaultStoreroom, store);
            }
        }
    },
    setDefaultStoreroom: function () {
        var div = $('#' + cafm.res.consts.ElementId_ChangeDefaultStoreroom);
        var store = div.getViewModel();
        cafm.stockmgt.cacheDefaultStoreroom(store,true);
        cafm.url.set();
    },
    getDefaultStoreroom: function () {
        return cafm.cache.session.get(cafm.res.consts.CacheKey_DefaultStoreroom);
    },
    getCurrencySymbolForCurrentBalance: function () {
        var sb = $('#' + cafm.res.consts.ElementId_StockAdjustBalanceForm).getViewModel();
        if (sb)
        {
            return sb.CurrencySymbol;
        }
    },
    getIdFromBalanceVM: function () {
        var crit = $('#' + cafm.res.consts.ElementId_StockBalanceForm).getViewModel();
        return crit.ID;
    },
    onPreBindBalanceFilters: function (criteria, filterPanel) {
        var defStr = cafm.stockmgt.getDefaultStoreroom();
        if (defStr)
        {
            criteria.StoreroomID = defStr.ID;
            criteria.StoreroomDescription = defStr.Description;
        }
        setTimeout(() => {
            cafm.filters.showPanel();
        }, 0);
    },
    refreshBalancesView: function () {
        if (cafm.stockmgt.requiesRefresh === true)
        {
            if (cafm.isMobile()) {
                cafm.lv.refreshSearchList();
            } else {
                cafm.grids.refreshSearchGrid();
            }
            cafm.stockmgt.requiesRefresh = false;
        }
        
        if (cafm.isMobile()) {
            $('#backBtn').show();
        }
    },
    stockFeaturesToolbar: {
        ok: function (e) {
            cafm.views.closeActionWindow();
        },
        cancel: function (e) {
            cafm.views.closeActionWindow();
            cafm.stockmgt.refreshBalancesView();
        },
        transfer: function (e) {
            var crit = $('#' + cafm.res.consts.ElementId_StockTransferForm).getViewModel();
            cafm.actions.execute({
                url: cafm.url.api('Stock/TransferStock'),
                values: crit,
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                statusCodeFuncs: {
                    200: function (r) {
                        $('#transferStock').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageStockTransferred });
                        cafm.views.closeActionWindow();
                        var balId = r.DestinationBalance.StockBalanceID;
                        cafm.stockmgt.requiesRefresh = true;
                        cafm.stockmgt.displayStockBalance(balId);
                    }
                }
            });
        },
        adjustbalance: function () {
            var crit = $('#' + cafm.res.consts.ElementId_StockAdjustBalanceForm).getViewModel();
            cafm.actions.execute({
                url: cafm.url.api('Stock/AdjustBalance'),
                values: crit,
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                statusCodeFuncs: {
                    200: function (r) {
                        $('#transferStock').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageStockTransferred });
                        cafm.stockmgt.requiesRefresh = true;
                        cafm.views.closeActionWindow();
                        var balId = r.Balance.StockBalanceID;
                        cafm.stockmgt.displayStockBalance(balId);
                    }
                }
            });
        },
        updatebinlocation: function () {
            var crit = $('#' + cafm.res.consts.ElementId_StockUpdateBinForm).getViewModel();
            cafm.actions.execute({
                url: cafm.url.api('Stock/UpdateBinLocation'),
                values: crit,
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                statusCodeFuncs: {
                    200: function (r) {
                        $('#transferStock').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageStockUpdated });
                        cafm.stockmgt.requiesRefresh = true;
                        cafm.views.closeActionWindow();
                        cafm.stockmgt.displayStockBalance(crit.ID);
                    }
                }
            });
        }
    },
    displayStockPhotoFromUrl: function (url) {
        cafm.stockmgt.displayStockPhotograph(null, url);
    },
    displayStockPhoto: function (formId){
        cafm.stockmgt.displayStockPhotograph(formId, null);
    },
    displayStockPhotograph:function(formId,url)
    {
        var url;
        if (formId) {
            url = $('#' + formId).getViewModel().StockPhotoUrl;
        }

        if (!url) {
            cafm.msg.showMessageInWindow({
                title: 'Image not found.',
                type: cafm.enums.MessageType.Error
            })
            return false;
        }

        var img = $('<img id="imgContent" src="{0}" />'.format(url));
        var wrapper = $('<div id="imgView"/>').append(img.css('display', 'block'));
        var win = wrapper.kendoWindow({
            draggable: false,
            resizable: false,
            modal: true,
            title: "Stock",
            activate: function (e) {
                $(window).on('click.winimg touchend.winimg', function () {
                    e.sender.close();
                });

                if (img[0].complete) {
                    img.scaleImageToViewPort(20);
                    var window = $("#imgView").data("kendoWindow");
                    window.center();
                } else {
                    $(img).on('load', function () {
                        $("#imgContent").scaleImageToViewPort(20);
                        var window = $("#imgView").data("kendoWindow");
                        window.center();
                    });
                    $(img).on('error', function () {
                        cafm.msg.showMessageInWindow({
                            title: 'Can not display the image.',
                            type: cafm.enums.MessageType.Error
                        });
                    });
                }
            },
            open: function (e) {
                e.sender.center();
            },
            close: function (e) {

                $(window).off('click.winimg touchend.winimg');
                setTimeout(function () {
                    cafm.util.kendoDestroy(e.sender.wrapper);
                    e.sender.wrapper.remove();
                }, 500)
            }
        }).data('kendoWindow');

        setTimeout(function () {
            win.open();
        }, 500)

        $(wrapper).on('click tap', function () {
            win.close();
        });

        return false;
    }
}